import { Box, Button, Tag, TagColor } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import {
  ReconciliationSource,
  ReconciliationStatusEnum,
  ReconciliationType,
} from 'modules/banking/hooks/useReconciliationForm'

interface TagLabelComponentProps {
  source?: ReconciliationSource | null
  dirty: boolean
  onReconcile: () => void
  onNoDocument?: () => void
}

export const TagLabelComponent = ({
  source,
  dirty,
  onReconcile,
  onNoDocument,
}: TagLabelComponentProps) => {
  const tagLabel = () => {
    switch (source?.reconciliationStatus) {
      case ReconciliationStatusEnum.Partial:
        return i18n.t('banking.reconciliations.total_summary.status.partially_reconciled')
      case ReconciliationStatusEnum.Full:
        return i18n.t('banking.reconciliations.total_summary.status.full_reconciled')
      default:
        return ''
    }
  }

  const tagColor = () => {
    switch (source?.reconciliationStatus) {
      case ReconciliationStatusEnum.Partial:
        return TagColor.champagne
      case ReconciliationStatusEnum.Full:
        return TagColor.lime
      default:
        return TagColor.neutral
    }
  }

  const reconcilatedAndNotDirtyForm =
    source?.reconciliationStatus === ReconciliationStatusEnum.Full && !dirty

  return (
    <Box width="full" paddingX="s8">
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <Box>
          {source && source.reconciliationStatus !== ReconciliationStatusEnum.None && (
            <Tag showCircle type={tagColor()} leftItem="circle" inline>
              {tagLabel()}
            </Tag>
          )}
        </Box>
        <Box>
          {source && source.reconciliationType === ReconciliationType.Invoice && (
            <Button disabled={reconcilatedAndNotDirtyForm} onClick={onReconcile}>
              {i18n.t('banking.reconciliations.total_summary.reconcile')}
            </Button>
          )}

          {source && source.reconciliationType === ReconciliationType.Transaction && (
            <Button.Split
              label={i18n.t('banking.reconciliations.total_summary.reconcile')}
              disabled={!source}
              onClick={() => {
                track(trackingEvents.accounting.banking.clickReconcile)
                onReconcile()
              }}
            >
              {onNoDocument && (
                <Button.Split.Option
                  onClick={() => {
                    track(trackingEvents.accounting.banking.clickNoDocumentReconciliation)
                    onNoDocument()
                  }}
                >
                  {i18n.t('banking.reconciliations.total_summary.no_document')}
                </Button.Split.Option>
              )}
            </Button.Split>
          )}
        </Box>
      </Box>
    </Box>
  )
}
